import HistoricOrderVM from '@/react/view-models/HistoricOrderVM';
import {
  useDeferredValue,
  useState,
  type FC,
  type PropsWithChildren
} from 'react';
import { OrderCancellationContext } from './OrderCancellationContext';

/**
 * The provider for the {@link HistoricOrderVM} used for order cancellation.
 * Done as a provider so the status of the cancellation request displays
 * properly in the order details page after starting the request started
 * from another page like the order confirmation details.
 */
export const OrderCancellationProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const [vm] = useState<HistoricOrderVM>(() => new HistoricOrderVM());
  const deferredContextValue = useDeferredValue(vm);
  return (
    <OrderCancellationContext value={deferredContextValue}>
      {children}
    </OrderCancellationContext>
  );
};
